import { PAGE_NAMES, GAME_ADMIN_RESOURCES, GAME_ADMIN_SCOPES } from 'constant';
import { ACTION_NAME, ACTION_ID, ActionListParam } from '../types';

export const makeActionList = (params: ActionListParam) => {
	const { hasPermission, appName } = params;
	return {
		rowActions: [
			{
				name: ACTION_NAME.REVERT,
				id: ACTION_ID.REVERT,
				isEnabled: () => {
					return hasPermission({
						entity: GAME_ADMIN_RESOURCES.zkRevertDashboard,
						actions: GAME_ADMIN_SCOPES[GAME_ADMIN_RESOURCES.zkRevertDashboard].revertZkConfigChange,
						appName,
						configPageName: PAGE_NAMES.gameAdmin
					});
				}
			}
		]
	};
};

export default {
	makeActionList
};
